import type { Goal } from '@feathr/blackbox';
import type { IDelta } from '@feathr/components';
import { useStore } from '@feathr/extender/state';

const EMPTY_DELTA: IDelta = { pct: 0, direction: 'none' };

export interface IUseGoalDetailReturn {
  goal: Goal;
  primaryOnCount: number;
  trackedOnCount: number;
  totalConversions: number;
  totalConversionValue: number;
  uniqueConverters: number;
  conversionsDelta: IDelta;
  valueDelta: IDelta;
  uniqueConvertersDelta: IDelta;
}

export function useGoalDetail(goalId: string): IUseGoalDetailReturn {
  const { Goals } = useStore();
  const goal = Goals.get(goalId);

  // Stats fields are returned by the backend but not yet typed in IGoal (blocked on #7382)
  const primaryOnCount: number = goal.get('primary_on_count') ?? 0;
  const trackedOnCount: number = goal.get('tracked_on_count') ?? 0;
  const totalConversions: number = goal.get('total_conversions') ?? 0;
  const totalConversionValue: number = goal.get('total_conversion_value') ?? 0;
  const uniqueConverters: number = goal.get('unique_converters') ?? 0;

  // TODO: replace with real period-over-period stats once goal-level agg endpoint is available (#7382)
  const conversionsDelta = EMPTY_DELTA;
  const valueDelta = EMPTY_DELTA;
  const uniqueConvertersDelta = EMPTY_DELTA;

  return {
    goal,
    primaryOnCount,
    totalConversions,
    totalConversionValue,
    trackedOnCount,
    uniqueConverters,
    conversionsDelta,
    valueDelta,
    uniqueConvertersDelta,
  };
}
